<!--  -->
<template>
  <div>
    <el-table
      :data="corpuseridoptions"
      border
      max-height="800"
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        label="名字"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="user_id"
        label="user_id"
        width="350"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="choosewe(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { filterUser } from '@/api/enterprisewechatControl'
export default {
  components: {},
  data() {
    return {
      box_id: null,
      corp_id: null,
      corpuseridoptions: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(box_id, corp_id) {
      this.box_id = box_id
      this.corp_id = corp_id
      this.sdawr()
    },
    async sdawr() {
      const data = await filterUser({
        corp_id: this.corp_id
      })
      this.corpuseridoptions = data.data
    },
    choosewe(backitem) {
      this.$emit('callbackwer', backitem, this.box_id)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>